import { configureStore } from "@reduxjs/toolkit";
import logger from "redux-logger";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";

import reducers from "./rootReducers";

const encryptor = encryptTransform({
  secretKey: import.meta.env.VITE_ENC_KEY,
  onError: function (error) {
    console.error("Encryption Error:", error);
  },
});

const persistConfig = {
  key: "root",
  storage,
  transforms: [encryptor],
};

const persistedReducers = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducers,
  middleware: (getDefaultMiddleware) => (import.meta.env.VITE_NODE_ENV === "development" ? getDefaultMiddleware().concat(logger) : getDefaultMiddleware()),
  devTools: import.meta.env.NODE_ENV !== "production",
});

if (import.meta.env.NODE_ENV !== "production" && import.meta.hot) {
  import.meta.hot.accept("./rootReducers", () => store.replaceReducer(persistedReducers));
}

const persistor = persistStore(store);

export { store, persistor };
